import { useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import { FlexiApprovedView } from './flexiApprovedView/FlexiApprovedView';
import { MicroLoanOfferView } from './microLoanOfferView/MicroLoanOfferView';
import { PriceCheckBanner } from './priceCheckBanner/PriceCheckBanner';
import { RecommendedOfferView } from './recommendedOfferView/RecommendedOfferView';
import { useGetApprovedViewData } from './useGetApprovedViewData';
import { FundingProgressIndicator } from '../../funding/fundingSteps/FundingProgessIndicator/FundingProgressIndicator';
import FallbackErrorModal from '../../modals/fallbackErrorModal/FallbackErrorModal';
import MainContentPending from '../../pageStructure/mainContentPending';

type TViewStatus =
    | 'recommended_offer_view'
    | 'micro_offer_view'
    | 'loan_builder_view';

export const ApprovedViewDE = () => {
    const {
        isLoading,
        isError,
        hasRBLOffer,
        hasSuitabilityOffer,
        hasMicroOffer,
        formalOffers
    } = useGetApprovedViewData();
    const [showAllOptions, setShowAllOptions] = useState(false);

    useEffect(() => {
        if (!isLoading && !isError) {
            const getViewStatus = (): TViewStatus => {
                if (hasSuitabilityOffer) return 'recommended_offer_view';
                if (hasMicroOffer) return 'micro_offer_view';
                else return 'loan_builder_view';
            };
            tracking.ampli.approvedViewVisited({ status: getViewStatus() });
        }
    }, [hasRBLOffer, hasMicroOffer, hasSuitabilityOffer, isLoading, isError]);

    const getOfferView = () => {
        if (hasSuitabilityOffer && !showAllOptions) {
            return (
                <RecommendedOfferView setShowAllOptions={setShowAllOptions} />
            );
        }
        if (hasMicroOffer) {
            return (
                <MicroLoanOfferView formalOfferId={formalOffers![0].offer_id} />
            );
        } else
            return <FlexiApprovedView setShowAllOptions={setShowAllOptions} />;
    };

    if (isLoading) {
        return <MainContentPending data-testid="approved-view-loading" />;
    }

    if (isError) {
        return <FallbackErrorModal />;
    }

    return (
        <>
            {!hasRBLOffer && <PriceCheckBanner />}
            <FundingProgressIndicator step={1} />
            {getOfferView()}
        </>
    );
};
